import simpleFetch from "../../../utils/simpleFetch";

class MemberIdentifierRecoveryApi {
  static request(model, body, headers, options, query) {
    return simpleFetch("post", model.path, { body, headers, options, query });
  }
}

export default MemberIdentifierRecoveryApi;



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryApi.js